import { useQuery } from "@tanstack/react-query";
import { fetchSuchanas } from "../services/suchanaService";

export const useFetchSuchanas = () => useQuery({
    queryKey: ['suchanas'],
    queryFn: fetchSuchanas
});
